import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import type { Bet } from '../types';

export const BET_SLICE_KEY = 'bet';

export interface CurrentBet {
  choice?: 'A' | 'B' | 'C';
  amount?: number;
  odds?: number;
  result?: 'WIN' | 'LOSS' | null;
  profit?: number;
}

export interface BetSliceState {
  bets: Bet[];
  currentBet: CurrentBet | null;
  numberOfBets: number;
  notifiedBetsSuccess: string[];
  notifiedBetsError: string[];
}

const initialState: BetSliceState = {
  bets: [],
  currentBet: null,
  numberOfBets: 0,
  notifiedBetsSuccess: [],
  notifiedBetsError: [],
};

const betSlice = createSlice({
  name: BET_SLICE_KEY,
  initialState,
  reducers: {
    setBets: (state, action: PayloadAction<Bet[]>) => {
      state.bets = [
        ...state.bets.filter(
          (bet) => !action.payload.some((newBet) => newBet.id === bet.id)
        ),
        ...action.payload,
      ];
    },
    setCurrentBet: (state, action: PayloadAction<CurrentBet | null>) => {
      state.currentBet = action.payload;
    },
    updateCurrentBet: (state, action: PayloadAction<Partial<CurrentBet>>) => {
      if (state.currentBet) {
        state.currentBet = { ...state.currentBet, ...action.payload };
      } else {
        state.currentBet = action.payload as CurrentBet;
      }
    },
    clearCurrentBet: (state) => {
      state.currentBet = null;
    },
    setNumberOfBets: (state, action: PayloadAction<number>) => {
      state.numberOfBets = action.payload;
    },
    betNotifiedSuccess: (state, action: PayloadAction<string>) => {
      state.notifiedBetsSuccess = [
        ...state.notifiedBetsSuccess,
        action.payload,
      ];
    },
    betNotifiedError: (state, action: PayloadAction<string>) => {
      state.notifiedBetsError = [...state.notifiedBetsError, action.payload];
    },
    resetBetSlice: () => initialState,
  },
});

const betReducer = betSlice.reducer as Reducer;

export default betReducer;

export const betSelector = (state: { [BET_SLICE_KEY]: BetSliceState }) =>
  state[BET_SLICE_KEY];

export const betActions = betSlice.actions;
